import { required, minLength, maxLength, minValue, maxValue, email } from 'vuelidate/lib/validators'
import said from '@/js/said.js'

const noyes = ['No', 'Yes']

const autotypes = [
    'Current Owner', //value: 0},
    'Previous Owner', //value: 1}
]

const termsselection = [
    '7 days',
    '14 days',
    '30 days',
    '60 days',
    '90 days',
    '120 days',
    '150 days',
    '180 days',
    '210 days',
    '240 days',
]

const periodLease = [
    '6 Months', 
    '12 Months', 
    '18 Months', 
    '24 Months', 
    '36 Months'
]

const genders = [
    'Male',
    'Female'
]

const entitiescomind = ['Company', 'Consumer']

const entitytypes = [
    'Consumer',
    'Company'
]

const entity = ['Registered Business', 'Sole Proprietor', 'Trust']

const provinces = [
    'Eastern Cape',
    'Free State',
    'Gauteng',
    'Kwazulu-Natal',
    'Limpopo',
    'Mpumalanga',
    'North West',
    'Northen Cape',
    'Western Cape',
]

const unitType = [
    'Units',
    'Exclusive Use Areas',
    'Contracts'
]

const deedsOffice = {
    1 : 'Bloemfontein',   
    2 : 'Cape Town', 
    3 : 'Johannesburg',   
    4 : 'Kimberley',   
    5 : 'King Williams Town',
    6 : 'Mpumalanga',   
    7 : 'Pietermaritzburg',   
    8 : 'Pretoria',   
    9 : 'Umtata',   
    10: 'Vryburg',   
    11: 'Limpopo'    
}    

// TU purpose and Expeirna purpose are the same

const tulistings = [
    'Absconded', // value: 0},
    'Bad Debt Written Off', // value: 1},
    'Final Notice', // value: 2},
    'Handed Over', // value: 3},
    'Return to Drawer Check', // value: 4},
    'Repossession', // value: 5},
    'Insurance Commissions', // value: 6},
]

const streetTypes = [
    'All Types',
    'Alley',
    'Avenue',
    'Boulevard',
    'Causeway',
    'Circle',
    'Close',
    'Crescent',
    'Drive',
    'Grove',
    'Highway',
    'Place',
    'Road',
    'Square',
    'Street',
    'Terrace',
    'Walk',
    'Way',
]
const colors = [
    'Unknown',
    'Black',
    'Blue',
    'Fuchsia',
    'Gold',
    'Gray',
    'Green',
    'Lime',
    'Maroon',
    'Navy',
    'Olive',
    'Orange',
    'Purple',
    'Red',
    'Silver',
    'Teal',
    'White',
    'Yellow',
]

const accountVerifyBanks = [
    "ABSA",
    "AFRICAN BANK",
    "CAPITEC",
    "CAPITEC BUSINESS",
    "DISCOVERY BANK",
    "FNB",
    "GRINDROD",
    "INVESTEC",
    "NEDBANK",
    "SASFIN BANK",
    "STANDARD BANK",
    "TYMEBANK"
]


const accountTypes = [
    'Current (Cheque) Account',
    'Savings Account',
    'Transmission',
    'Bond',
    'Subscription Share',
]
const marisitAccountTypes = [
    'Unknown',
    'Current (Cheque) Account',
    'Transmission',
    'Bond',
    'Credit Card',
    'Subscription',
]

const shortrepaymentterms = [
    '30 Days',
    '60 Days',
    '90 Days',
    '120 Days',
    'COD',
]

const qualifications = [
    'Degrees',
    'Diplomas',
    'Certifications',
    'Trade Test Certificate',
    'Grade 10/11',
]

const fileTypes = ".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf"

const staticImageTypes = ".jpg,.jpeg,.png"

function errorTelephone(v) {
    if (v.$error === false) {
        return false
    }
    return 'Telephone should contain exactly 10 digits'
}

function errorRegNo(v) {
    if (v.$error === false) {
        return false
    }
    if (v.required === false) {
        return 'Required'
    }
    if (v.year === false) {
        return 'Year segment should contain exactly 4 digits'
    }
    if (v.number === false) {
        return 'Number segment should contain exactly 6 digits'
    } 
    if (v.type === false) {
        return 'Type segemnt should contain exactly 2 digits'
    }
    if (v.valid === false) {
        return 'Registration number should be 12 digits'
    }
    return false
}
function smsmessage(v) {
    if (v.$error === false) {
        return false
    }
    if (v.required === false) {
        return 'Required'
    }
    if (v.maxLength === false) {
        return 'Message length limit is 459 characters'
    }
    return false
}

function errorEmail(v) {
    if (v.$error === false) {
        return false
    }
    return 'Invalid email address';
}

function errorRequired(v) {
    if (v.$error === false) {
        return false
    }
    return 'Required';
}

function errorId(id) {
    if (id.$error === false) {
        return false
    }
    if (id.length === false) {
        return 'ID Number can only be 13 characters'
    }
    if (id.valid === false) {
        return 'Invalid ID Number'
    }
    return false
}

function errorAge(age) {
    if (age.$error === false) {
        return false
    }
    if (age.minValue === false || age.maxValue === false) {
        return 'Invalid age.'
    }
    return false
}

function errorPostalCode(v) {
    if (v.$error === false) {
        return false
    }
    return 'Postal Code should contain exactly 4 digits'
}

const validations = {
    idNumber: {
        length: val => !!val && val.length == 13,
        valid(val) {
            let ret = said(val)
            return ret && ret.valid
        }
    },
    required: { required },
    accept: {
        valid(val) {
            return val === true
        }
    },
    regNo: {
        required(v) {
            return !!(v && v.number)
        },
        year(v) {
            return !!(v && v.reg1 && v.reg1.length == 4)
        },
        number(v) {
            return !!(v && v.reg2 && v.reg2.length == 6)
        },
        type(v) {
            return !!(v && v.reg3 && v.reg3.length == 2)
        },
        valid(v) {
            if (!v || !v.number) {
                return false
            }
            return v.number.length == 12
        }
    },
    telephone: { required, maxLength: maxLength(10), minLength: minLength(10) },
    postalCode: { required, maxLength: maxLength(4), minLength: minLength(4) },
    age: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(100)
    },
    emailRequired: {
        required, valid(v) {
            return !!validateEmail(v)
        }
    },
    email: {
        valid(v) {
            if (v)
                return !!validateEmail(v)
            return true
        }
    }
}

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

const types = {
    accountVerifyBanks,
    periodLease,
    errorRegNo,
    errorTelephone,
    errorRequired,
    errorEmail,
    errorId,
    errorAge,
    errorPostalCode,
    noyes,
    autotypes,
    termsselection,
    entitiescomind,
    entitytypes,
    provinces,
    deedsOffice,
    tulistings,
    streetTypes,
    colors,
    accountTypes,
    marisitAccountTypes,
    fileTypes,
    staticImageTypes,
    shortrepaymentterms,
    unitType,
    qualifications,
    entity,
    genders,
    smsmessage
} 


export { types }
export { validations }